// extracted by mini-css-extract-plugin
module.exports = {"certification-card":"certification-card___3asfT","certification-descriptions":"certification-descriptions___1aykT"};